import axios from "axios";

export const node_env = process.env.REACT_APP_NODE_ENV;

// FRONTEND

export const WEBSITE_URL = node_env === 'development' ?
    process.env.REACT_APP_WEBSITE_URL_DEVELOPMENT :
    process.env.REACT_APP_WEBSITE_URL_PRODUCTION;

// BACKEND
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_ACTIVE_TEACHERS;

export const API_URL = node_env === 'development' ?
    process.env.REACT_APP_DEVELOPMENT_URL :
    process.env.REACT_APP_PRODUCTION_URL;

const api = axios.create({
    baseURL: API_URL
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem("teacherToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

